module.exports = __webpack_public_path__ + "img/IMG_0057_L_BlackMatted_MockedUp.d80440a8.jpg";